import { coreDefaultTheme } from '@kite-js/theme';
import { ButtonTheme, ButtonThemeProps } from '@kite-js/theme-types';

const Button: ButtonTheme = {
    ...coreDefaultTheme.button,
    default: {
        loader: 'cylindrical',
    },
};

export default Button;
